<template>
  <div class="list-group list-group-flush list-group-sm text-start mx-n2">
    <div
      v-for="(item, index) in values"
      :key="index"
      class="list-group-item list-group-item-kvp gap-4 border-0 text-bg-dark bg-transparent"
    >
      <span class="me-auto">{{ item.label }}</span>
      <span class="badge text-bg-secondary rounded-pill">{{ item.value.toLocaleString() }}</span>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  values: {
    type: Array,
    default: () => ([]),
  },
})

const { values } = toRefs(props)
</script>
